export default __webpack_public_path__ + "static/media/webm.065b3808.svg";